// TODO: Should get flags and state from 'lv_obj.xml' [Architectural Improvement]
import { SelectorFlags } from './types';

export const LV_PARTS: string[] = [
    'MAIN',
    'SCROLLBAR',
    'INDICATOR',
    'KNOB',
    'SELECTED',
    'ITEMS',
    'TICKS',
    'CURSOR',
    'CUSTOM_FIRST',
    'TEXTAREA_PLACEHOLDER',
    'ANY'
] as const;

export const LV_STATES: string[] = [
    'DEFAULT',
    'CHECKED',
    'FOCUSED',
    'FOCUS_KEY',
    'EDITED',
    'HOVERED',
    'PRESSED',
    'SCROLLED',
    'DISABLED',
    'USER_1',
    'USER_2',
    'USER_3',
    'USER_4',
    'ANY'
] as const;

const isLvPart = (value: string): boolean => LV_PARTS.includes(value.toUpperCase());

const isLvState = (value: string): boolean => LV_STATES.includes(value.toUpperCase());

export const parseSelectorFlags = (styleString: string): SelectorFlags => ({
    parts: styleString.split('|').filter((flag) => isLvPart(flag.toUpperCase())),
    states: styleString.split('|').filter((flag) => isLvState(flag.toUpperCase()))
});
